module.exports = __webpack_public_path__ + "img/6-2.2b510b50.png";